<template>
  <footer class="main-footer"><strong>АО МКК «СПб ЦДЖ»</strong></footer>
</template>